import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/accordion/accordion.module.css
var css_248z = ".accordion-module_root__Jp-Ld {\n    --accordion-chevron-size: 1.5rem;\n}\n\n.accordion-module_item__qfZXb {\n    border-bottom: 0;\n}\n\n.accordion-module_icon__9NZbY,\n.accordion-module_label__Clppv {\n    color: var(--mantine-color-gray-9);\n}\n\n.accordion-module_label__Clppv {\n    padding: 0;\n}\n\n.accordion-module_control__lfhKq {\n    padding: var(--mantine-spacing-xs) 0;\n}\n\n.accordion-module_content__1WTaS {\n    padding: var(--mantine-spacing-xxxs) 0 var(--mantine-spacing-sm) 0;\n}\n\n.accordion-module_chevron__yZOb8 {\n    align-self: flex-start;\n}\n";
var accordion_module_default = {
	"root": "accordion-module_root__Jp-Ld",
	"item": "accordion-module_item__qfZXb",
	"icon": "accordion-module_icon__9NZbY",
	"label": "accordion-module_label__Clppv",
	"control": "accordion-module_control__lfhKq",
	"content": "accordion-module_content__1WTaS",
	"chevron": "accordion-module_chevron__yZOb8"
};
style_inject_es_default(css_248z);

//#endregion
export { accordion_module_default as default };